import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/angle-down-white.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  id: "tabsFixed",
  class: "fold-menu-section"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "custom-row" }
const _hoisted_7 = { class: "fold_menu" }
const _hoisted_8 = { id: "teleporter" }
const _hoisted_9 = ["id", "onClick"]
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"fold_menu_receiver\"><ul id=\"receiver\"></ul><div class=\"menu_arrow\"><button id=\"receiverClick\"><img src=\"" + _imports_0 + "\" alt=\"\"></button></div></div>", 1)
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "container clearfix" }
const _hoisted_13 = { class: "big-picture" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  class: "picture-content showcontent",
  id: "readMoewaa"
}
const _hoisted_16 = { class: "fold-txt-box" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "b_p_txt" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "page_link"
}
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", {
        class: "page-banner-section",
        style: _normalizeStyle({ 'background-image': `url(${require('@/assets/images/our-services-banner.jpg')})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants['OUR_SERVICES_TEXT']), 1)
        ])
      ], 4),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceData, (service, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("a", {
                      id: `tabs${index.toString()}`,
                      href: "javascript:void(0);",
                      onClick: ($event: any) => (_ctx.scrollToSection(service.id))
                    }, _toDisplayString(service.title), 9, _hoisted_9)
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_10
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceData, (service, index) => {
        return (_openBlock(), _createElementBlock("section", {
          id: 'section' + service.id,
          class: _normalizeClass(['big-picture-fold', index % 2 === 0 ? 'b-f-left' : 'b-f-right']),
          key: service.id
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: _ctx.getCdnImageAddress(service.serviceImage, `w_575,h_457/`),
                alt: ""
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h4", null, _toDisplayString(service.title), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h5", null, [
                  _createElementVNode("p", {
                    innerHTML: service.shortDescription
                  }, null, 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.getServiceDescription(service)
                  }, null, 8, _hoisted_19)
                ])
              ]),
              (_ctx.shouldShowServiceReadMore(service))
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      id: "readMoewa",
                      onClick: ($event: any) => (_ctx.toggleServiceDescription(service.id))
                    }, _toDisplayString(_ctx.isExpandedService(service.id) ? '<< Read Less' : 'Read More >>'), 9, _hoisted_21)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 10, _hoisted_11))
      }), 128))
    ]),
    _createVNode(_component_userFooter)
  ]))
}